var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import WithRender from './Select.html';
// Note: We don't use material select box yet.
let Select = class Select extends Vue {
    // Note: We don't use material select box yet.
    constructor() {
        super(...arguments);
        this.selectedValue = this.value;
        this.focus = false;
    }
    get classes() {
        return {
            'mdc-select--disabled': this.disabled,
            'mdc-select--active': this.focus,
            'mdc-select--error': this.error,
        };
    }
    onValueUpdate() {
        this.selectedValue = this.value;
    }
    // When user selects any item from select dropdown
    onInput($event) {
        this.$emit('input', $event.target.value);
    }
    onFocus() {
        this.focus = true;
        this.$emit('focus');
    }
    onBlur() {
        this.focus = false;
        this.$emit('blur');
    }
    onDropdownClick($event) {
        this.$refs.selectInput.click();
        $event.stopPropagation();
    }
};
__decorate([
    Prop({ default: () => [] }),
    __metadata("design:type", Array)
], Select.prototype, "options", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], Select.prototype, "error", void 0);
__decorate([
    Prop({ type: [Object, String, Number, Boolean] }),
    __metadata("design:type", Object)
], Select.prototype, "value", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], Select.prototype, "disabled", void 0);
__decorate([
    Watch('value'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Select.prototype, "onValueUpdate", null);
Select = __decorate([
    WithRender,
    Component({})
], Select);
export { Select };
//# sourceMappingURL=Select.js.map